import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';

import { IntersectionObserverDirective } from '../../directives';
import { ButtonModule } from '../button/button.module';
import { StickyDrawerDrawerDirective } from './sticky-drawer-drawer.directive';
import { StickyDrawerFooterDirective } from './sticky-drawer-footer.directive';
import { StickyDrawerComponent } from './sticky-drawer.component';

const publicApi = [
  StickyDrawerComponent,
  StickyDrawerDrawerDirective,
  StickyDrawerFooterDirective,
];

@NgModule({
  imports: [
    CommonModule,
    IntersectionObserverDirective,
    MatSidenavModule,
    ButtonModule,
    MatIconModule,
  ],
  declarations: [...publicApi],
  exports: [...publicApi],
})
export class StickyDrawerModule {}
